import { useMemo } from 'react';
import useQueryParams from '../../shared/use-query-params';

export function useHolisticProjectReportBackLink() {
  const query = useQueryParams();
  return useMemo(() => {
    if (query.from) {
      return query.from;
    }
    // Default to scheduled reports tab with anchor
    return '/holistic-project-reports#scheduled';
  }, [query]);
}
